import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';

import {ArmyList} from "@Models";
import {container} from "@Container";
import {ArmyListAction} from "@Redux/actions";
import {TYPES} from "@Types";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import armyListSlice from '@Redux/reducers/builder/armyList.slice';

const ArmyListPaint: React.FC<ArmyListPaintProps> = ({armyList, isLoading, cancel, toPaint}) => {

  return (
    <div className="mt-2 text-center">
      <h1><FormattedMessage {...defaultMessages.armyListPaintFormTitle} /></h1>
      <p><FormattedMessage {...defaultMessages.armyListPaintFormAction} /> <strong>{armyList?.name}</strong> ?</p>
      {!isLoading &&
        armyList != null &&
          <div className="action">
              <button className="btn btn-age" type="button" onClick={() => cancel()}><FormattedMessage {...defaultMessages.formCancel} /></button>
              <button className="btn btn-age" type="button" onClick={() => toPaint(armyList)}><FormattedMessage {...defaultMessages.formValidate} /></button>
          </div>}
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  isLoading: state.armyList.isLoading,
  armyList: state.armyList.entity,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListAction = container.get<ArmyListAction>(TYPES.Actions.ArmyListAction);
  return {
    toPaint: (armyList: ArmyList) => dispatch(armyListAction.createPaintList(armyList)),
    cancel: () => dispatch(armyListSlice.actions.cancel())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListPaint);

type ArmyListPaintProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
